import { Text, View } from "react-native";
import { MedicationReportModel } from "app/services/api/types/medications/models/MedicationReportModel";
import { getFullName } from "ui/utils/nameUtil";
import MedicationTimeContent from "./MedicationTimeContent";
import { MedicationAdministrationStatusEnum } from "../../../services/api/types/medications/enums/MedicationAdministrationStatusEnum";
import { snakeToSentence } from "ui/utils/textUtils";

interface Props {
  medication: MedicationReportModel;
  showLabel?: boolean;
}

export default function ReportCardContent({ medication, showLabel }: Props) {
  const isAdministered =
    medication.status === MedicationAdministrationStatusEnum.ADMINISTERED;
  const isSelfAdministered =
    medication.status === MedicationAdministrationStatusEnum.SELF_ADMINISTERED;
  const isSkipped =
    medication.status === MedicationAdministrationStatusEnum.SKIPPED;

  return (
    <View className="flex flex-col gap-6">
      <View className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <View className="flex flex-col">
          {showLabel ? (
            <Text className="text-gray-600 mb-2">Medication</Text>
          ) : null}
          <Text className="font-semibold">{medication?.medication.name}</Text>
          <View className="flex-row items-center gap-x-2">
            <Text className="text-sm text-typography-600">
              Dosage: {medication?.medication.dosage}
            </Text>
          </View>
        </View>
        <View className="flex flex-col">
          <Text className="text-gray-600 mb-2">Actioned by</Text>
          <Text>
            {getFullName(medication?.administrator)} on
            <MedicationTimeContent time={medication.created_at} />
          </Text>
        </View>
      </View>
      <View className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <View className="flex flex-col">
          <Text className="text-gray-600 mb-2">Status</Text>
          <Text className="capitalize">
            {snakeToSentence(medication.status)}
          </Text>
        </View>
        {isAdministered || isSelfAdministered ? (
          <View className="flex flex-col">
            <Text className="text-gray-600 mb-2">Notes</Text>
            <Text>{medication.other_information ?? "No notes provided"}</Text>
          </View>
        ) : isSkipped ? (
          <View className="flex flex-col">
            <Text className="text-gray-600 mb-2">Reason</Text>
            <Text>{medication.skip_reason}</Text>
          </View>
        ) : null}
      </View>
    </View>
  );
}
